var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar-clock",
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "#FFFFF",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21h-4.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3v4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3v4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11h10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.5v1.5l.5 .5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarClock);
export default __webpack_public_path__ + "static/media/calendar_clock.45840c98fe931eb050aa32c1eba920d9.svg";
export { ForwardRef as ReactComponent };